export const getDecimalPlaces = (value: number | string) => {
  const valueString = value.toString();

  if (valueString.includes('.')) {
    // Split the number at the decimal point and return the length of the fractional part
    return valueString.split('.')[1].length;
  } else {
    // No decimal point means 0 decimal places
    return 0;
  }
};

export const countDigits = (numStr: string | number) => {
  const digitsOnly = numStr.toString().replace('.', '').replace('-', '');

  return digitsOnly.length;
};
